module.exports = __webpack_public_path__ + "img/app-logo.d2b84335.svg";